import React, { Component } from 'react';
import './Champ.css';

/**
 * Components
 */
import ChampView from './ChampView';

/* Modules */
import { message } from 'antd';
import { getChamp, updateChamp } from '../../utils/champsFunctions';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getUserByEmail } from '../../utils/usersFunctions';
import { getTeams, getWeightChart } from '../../utils/competitorsFunctions';

class Champ extends Component {

    constructor(props) {
        super(props)
        this.state = {
            champObject: '',

            userType: '',

            generalInfoDialog: false,
            loadingGeneralInfo: true,
            setGeneralInfoButton: false,
            generalInfoRegistrationStatus: '',
            generalInfoConfrontationPerTime: '',
            generalInfoConfrontationTime: '',
            generalInfoStartChamp: '',

            modalRegistration: false,
            quadroDePesos: [],
            arrayOfTeams: [],

            modalTeam: false,
        }
    }

    componentWillMount = async () => {
        window.scrollTo(0, 0)

        /* Get key of champs */
        let arrayOfLocation = this.props.location.pathname.split('/');

        const champId = arrayOfLocation[3];

        /* Get specific champ object */
        let champ = await getChamp(champId);
        champ['__key'] = champ.id;
        this.setState({
            champObject: champ
        });

        // Get user type
        const auth = getAuth();
        onAuthStateChanged(auth, async (user) => {
            if (user) {
                const userFound = await getUserByEmail(user.email);
                if (userFound) this.setState({ userType: userFound.type })
            }
        });

        /* Get all teams */
        const localTeamArray = await getTeams();
        this.setState({ arrayOfTeams: localTeamArray });

        /* get weight chart */
        const weightChart = await getWeightChart();
        this.setState({ quadroDePesos: weightChart });
    }

    /* General info modal stuffs */
    openGeneralInfoDialog = async () => {
        /* Get key of champs */
        let arrayOfLocation = this.props.location.pathname.split('/')

        this.setState({
            generalInfoDialog: true,
            loadingGeneralInfo: true
        })

        const champId = arrayOfLocation[3];
        const champ = await getChamp(champId);
        this.setState({
            generalInfoRegistrationStatus: champ.registrationStatus,
            generalInfoConfrontationPerTime: Number(champ.confrontationPerTime),
            generalInfoConfrontationTime: Number(champ.confrontationTime),
            generalInfoStartChamp: Number(champ.startChamp),
            loadingGeneralInfo: false
        });
    }

    closeGeneralInfoDialog = () => {
        this.setState({
            generalInfoDialog: false,
            setGeneralInfoButton: false,
        })
    }

    registrationStatus = (value) => {
        this.setState({
            generalInfoRegistrationStatus: value
        })
    }

    addGeneralInfoFieldValue = (field, value) => {
        if (field === 'confrontationPerTime') {
            this.setState({
                generalInfoConfrontationPerTime: value
            })
        } else if (field === 'confrontationTime') {
            this.setState({
                generalInfoConfrontationTime: value
            })
        } else if (field === 'startChamp') {
            this.setState({
                generalInfoStartChamp: value
            })
        }
    }

    /* Registration modal stuffs */
    openModalRegistration = () => {
        this.setState({ modalRegistration: true })
    }

    closeModalRegistration = () => {
        this.setState({ modalRegistration: false })
    }

    setGeneralInfo = async () => {
        this.setState({ setGeneralInfoButton: true });
        /* Get key of champs */
        let arrayOfLocation = this.props.location.pathname.split('/');

        const champId = arrayOfLocation[3];

        const callbackUpdatedChamp = await updateChamp(
            champId,
            {
                registrationStatus: this.state.generalInfoRegistrationStatus,
                confrontationPerTime: this.state.generalInfoConfrontationPerTime,
                confrontationTime: this.state.generalInfoConfrontationTime,
                startChamp: this.state.generalInfoStartChamp
            },
        );

        if (!callbackUpdatedChamp.error) {
            this.closeGeneralInfoDialog();
            message.success('Informações atualizadas com sucesso');
        } else {
            message.error(callbackUpdatedChamp.message);
            this.setState({ setGeneralInfoButton: true });
        }
    }

    openModalTeam = () => {
        this.setState({ modalTeam: true })
    }

    closeModalTeam = () => {
        this.setState({ modalTeam: false })
    }

    render() {
        return (
            <ChampView
                champObject={this.state.champObject}

                userType={this.state.userType}

                generalInfoDialog={this.state.generalInfoDialog}
                openGeneralInfoDialog={() => this.openGeneralInfoDialog()}
                closeGeneralInfoDialog={() => this.closeGeneralInfoDialog()}
                registrationStatus={v => this.registrationStatus(v)}
                addGeneralInfoFieldValue={(f, v) => this.addGeneralInfoFieldValue(f, v)}
                setGeneralInfo={() => this.setGeneralInfo()}
                loadingGeneralInfo={this.state.loadingGeneralInfo}
                generalInfoRegistrationStatus={this.state.generalInfoRegistrationStatus}
                generalInfoConfrontationPerTime={this.state.generalInfoConfrontationPerTime}
                generalInfoConfrontationTime={this.state.generalInfoConfrontationTime}
                generalInfoStartChamp={this.state.generalInfoStartChamp}
                setGeneralInfoButton={this.state.setGeneralInfoButton}

                modalRegistration={this.state.modalRegistration}
                openModalRegistration={() => this.openModalRegistration()}
                closeModalRegistration={() => this.closeModalRegistration()}
                quadroDePesos={this.state.quadroDePesos}
                arrayOfTeams={this.state.arrayOfTeams}

                modalTeam={this.state.modalTeam}
                openModalTeam={() => this.openModalTeam()}
                closeModalTeam={() => this.closeModalTeam()}
            />
        )
    }

}

export default Champ